"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _clientAwsS = require("@devsta/client-aws-s3");

var _classnames = _interopRequireDefault(require("classnames"));

var _VideoDetails = _interopRequireDefault(require("./VideoDetails"));

var _components = require("../../../../../common/components");

var _AssignOwnerModal = _interopRequireDefault(require("./AssignOwnerModal"));

var _AssignEditorModal = _interopRequireDefault(require("./AssignEditorModal"));

var _CollaboratorsModal = _interopRequireDefault(require("./CollaboratorsModal"));

require("../styles/_general-info.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MODAL = {
  OWNER: 'OWNER',
  EDITOR: 'EDITOR',
  COLLABORATORS: 'COLLABORATORS'
};

var getOwner = function getOwner(collaborators) {
  return collaborators.find(function (_ref) {
    var role = _ref.role;
    return role && role.name === 'OWNER';
  });
};

var GeneralInfo = /*#__PURE__*/function (_Component) {
  _inherits(GeneralInfo, _Component);

  var _super = _createSuper(GeneralInfo);

  function GeneralInfo(props) {
    var _this;

    _classCallCheck(this, GeneralInfo);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (openedModal) {
      return function () {
        _this.setState({
          openedModal: openedModal
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "fetchEditor", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getEditor, _yield$getEditor, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getEditor = _this.props.getEditor;

              if (getEditor) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", null);

            case 3:
              _context.next = 5;
              return getEditor();

            case 5:
              _yield$getEditor = _context.sent;
              data = _yield$getEditor.data;
              error = _yield$getEditor.error;

              if (!error) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return", null);

            case 10:
              return _context.abrupt("return", _this.setState({
                editor: data.getUser
              }));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchCreator", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var getCreator, _yield$getCreator, data, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getCreator = _this.props.getCreator;
              _context2.next = 3;
              return getCreator();

            case 3:
              _yield$getCreator = _context2.sent;
              data = _yield$getCreator.data;
              error = _yield$getCreator.error;

              if (!error) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return");

            case 8:
              _this.setState({
                creator: data.getUser
              });

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "fetchOrganisation", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this$props, getOrganisation, apolloClient, _yield$getOrganisatio, data, error, organisationWithImage;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, getOrganisation = _this$props.getOrganisation, apolloClient = _this$props.apolloClient;
              _context3.next = 3;
              return getOrganisation();

            case 3:
              _yield$getOrganisatio = _context3.sent;
              data = _yield$getOrganisatio.data;
              error = _yield$getOrganisatio.error;

              if (!error) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return");

            case 8:
              _context3.next = 10;
              return (0, _clientAwsS.replaceBucketKeysWithUrls)({
                apiClient: apolloClient,
                data: data.getOrganisation,
                substitutedKeys: ['imageUrl']
              });

            case 10:
              organisationWithImage = _context3.sent;

              _this.setState({
                organisation: organisationWithImage
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        openedModal: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOwnerChanged", function (collaborators) {
      var updateVideoData = _this.props.updateVideoData;
      updateVideoData({
        collaborators: collaborators
      });

      _this.setState({
        ownerCollaborator: getOwner(collaborators)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEditorChanged", function (editor) {
      var _this$props2 = _this.props,
          updateVideoData = _this$props2.updateVideoData,
          outputs = _this$props2.video.outputs;
      updateVideoData({
        outputs: outputs.map(function (output) {
          return output.isMaster ? _objectSpread({}, output, {
            assignedEditorId: editor.userId
          }) : output;
        })
      });

      _this.setState({
        editor: editor
      });
    });

    var _collaborators = props.video.collaborators;
    _this.state = {
      openedModal: '',
      ownerCollaborator: getOwner(_collaborators)
    };
    return _this;
  }

  _createClass(GeneralInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchOrganisation();
      this.fetchCreator();
      this.fetchEditor();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          video = _this$props3.video,
          assets = _this$props3.assets,
          containerSize = _this$props3.containerSize;
      var _this$state = this.state,
          organisation = _this$state.organisation,
          creator = _this$state.creator,
          editor = _this$state.editor,
          ownerCollaborator = _this$state.ownerCollaborator,
          openedModal = _this$state.openedModal;
      var collaborators = video.collaborators,
          outputs = video.outputs;

      var _outputs$find = outputs.find(function (_ref5) {
        var isMaster = _ref5.isMaster;
        return isMaster;
      }),
          assignedEditorId = _outputs$find.assignedEditorId,
          outputId = _outputs$find.outputId;

      var hasUpdatePermission = (0, _commonReact.hasPermission)('UPDATE', video.permissions);
      var isMedium = containerSize.width < _vars.NUMERIC_MEDIA_SIZES.medium;
      var owner = ownerCollaborator && ownerCollaborator.user;
      var collaboratorUsers = collaborators.map(function (_ref6) {
        var user = _ref6.user;
        return user;
      }).filter(Boolean);
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('general-info', {
            'general-info--medium': isMedium
          })
        }, /*#__PURE__*/_react.default.createElement(_AssignOwnerModal.default, {
          visible: openedModal === MODAL.OWNER,
          onClose: this.closeModal,
          ownerCollaborator: ownerCollaborator,
          videoId: video.videoId,
          onOwnerChanged: this.onOwnerChanged,
          organisationId: video.organisationId
        }), organisation && organisation.editingTeamId && /*#__PURE__*/_react.default.createElement(_AssignEditorModal.default, {
          visible: openedModal === MODAL.EDITOR,
          onClose: this.closeModal,
          onEditorChanged: this.onEditorChanged,
          assignedEditorId: assignedEditorId,
          outputId: outputId,
          teamId: organisation.editingTeamId
        }), /*#__PURE__*/_react.default.createElement(_CollaboratorsModal.default, {
          visible: openedModal === MODAL.COLLABORATORS,
          collaborators: collaboratorUsers,
          onClose: this.closeModal
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__video-details"
        }, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
          iconName: "video",
          title: "Video Details"
        }), /*#__PURE__*/_react.default.createElement(_VideoDetails.default, {
          video: video,
          assets: assets,
          organisation: organisation,
          owner: creator,
          hasUpdatePermission: hasUpdatePermission
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__contacts"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__contacts__primary"
        }, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
          iconName: "user",
          title: "Primary Contact"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('general-info__contacts__block', 'general-info__contacts__primary__block')
        }, owner ? /*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
          className: "general-info__contact-details",
          imageUrl: owner.imageUrl,
          defaultImageIcon: "user"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__title"
        }, (0, _getUserFullName.default)(owner)), /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__subtitle"
        }, owner.jobTitle), /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__description"
        }, [owner.phoneNumber, owner.email].filter(Boolean).join(' | '))) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          onClick: this.openModal(MODAL.OWNER),
          small: true,
          type: "SECONDARY"
        }, "ASSIGN OWNER"), /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contacts__block__title"
        }, "Collaborators (".concat(collaboratorUsers.length, ")")), /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__contacts__primary__collaborators"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__contacts__primary__collaborators__list",
          tabIndex: 0,
          role: "button",
          onClick: this.openModal(MODAL.COLLABORATORS),
          onKeyPress: null
        }, /*#__PURE__*/_react.default.createElement(_uiKit.ResourceMembers, {
          members: collaboratorUsers,
          imageSize: "40px"
        }))))), /*#__PURE__*/_react.default.createElement("div", {
          className: "general-info__contacts__editor"
        }, /*#__PURE__*/_react.default.createElement(_components.SectionHeader, {
          iconName: "user",
          title: "Video Editor"
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('general-info__contacts__block', 'general-info__contacts__block__editor')
        }, editor ? /*#__PURE__*/_react.default.createElement(_components.EntityFormBlock, {
          className: "general-info__contact-details",
          imageUrl: editor.imageUrl,
          defaultImageIcon: "user"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__title"
        }, (0, _getUserFullName.default)(editor)), /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__subtitle"
        }, editor.jobTitle), /*#__PURE__*/_react.default.createElement("p", {
          className: "general-info__contact-details__description"
        }, editor.email)) : null, /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
          onClick: this.openModal(MODAL.EDITOR),
          small: true,
          type: "SECONDARY"
        }, "ASSIGN EDITOR")))))
      );
    }
  }]);

  return GeneralInfo;
}(_react.Component);

exports.default = GeneralInfo;